export const removeDuplicates=(arr:any)=> {
    return arr?.filter((item:any,index:number) => arr?.indexOf(item) === index);
}

export const AdminAccess =(data:any)=>{
    let temp = (data?.role_names?.includes("Admin") || data?.role_names?.includes("CFO"))
    return temp
}